import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-striped-circle',
  template: `
    <div class="striped-circle-container" [style.width.px]="size" [style.height.px]="size">
      <svg [attr.width]="size" [attr.height]="size" [attr.viewBox]="'0 0 ' + size + ' ' + size">
        <!-- Define pattern for parallel stripes -->
        <defs>
          <pattern [id]="'stripePattern' + uniqueId" patternUnits="userSpaceOnUse"
                   [attr.width]="stripeWidth + stripeGap" [attr.height]="stripeWidth + stripeGap"
                   patternTransform="rotate(45)">
            <line x1="0" y1="0" [attr.x2]="0" [attr.y2]="stripeWidth + stripeGap"
                  [attr.stroke]="color" [attr.stroke-width]="stripeWidth" />
          </pattern>
        </defs>

        <!-- Background circle -->
        <circle
          [attr.cx]="size/2"
          [attr.cy]="size/2"
          [attr.r]="radius"
          fill="none"
          [attr.stroke]="bgColor"
          [attr.stroke-width]="strokeWidth">
        </circle>

        <!-- Striped circle using pattern -->
        <circle
          [attr.cx]="size/2"
          [attr.cy]="size/2"
          [attr.r]="radius"
          fill="none"
          [attr.stroke]="'url(#stripePattern' + uniqueId + ')'"
          [attr.stroke-width]="strokeWidth">
        </circle>

        <!-- Center content - added to match CircularProgressComponent -->
        <foreignObject
          [attr.x]="(size - contentSize) / 2"
          [attr.y]="(size - contentSize) / 2"
          [attr.width]="contentSize"
          [attr.height]="contentSize">
          <div xmlns="http://www.w3.org/1999/xhtml" class="center-content">
            <ng-content></ng-content>
          </div>
        </foreignObject>
      </svg>
    </div>
  `,
  styles: [`
    .striped-circle-container {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .center-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `]
})
export class StripedCircleComponent implements OnInit {
  // Essential inputs for appearance
  @Input() color: string = '#4AFF52';       // Stripe color
  @Input() bgColor: string = '#D2FFD4';     // Background circle color
  @Input() size: number = 100;              // Overall container size

  // Optional configuration with sensible defaults
  @Input() strokeWidth: number = 10;        // Width of the circle stroke
  @Input() stripeWidth: number = 3;         // Width of each stripe
  @Input() stripeGap: number = 3;           // Gap between stripes

  // Calculated properties
  radius: number = 0;
  uniqueId: string = '';
  contentSize: number = 0;

  ngOnInit() {
    this.calculateRadius();
    this.calculateContentSize();
    // Generate a unique ID to prevent pattern conflicts when multiple components are used
    this.uniqueId = Math.random().toString(36).substring(2, 9);
  }

  ngOnChanges() {
    this.calculateRadius();
    this.calculateContentSize();
  }

  calculateRadius() {
    // Calculate radius based on size and stroke width
    this.radius = (this.size / 2) - (this.strokeWidth / 2);
  }

  calculateContentSize() {
    // Calculate content size the same way as in CircularProgressComponent
    this.contentSize = this.size - (this.strokeWidth * 2);
  }
}
